class opersnrol {
  constructor(operId, nombre,rolId) {
    this.operId = operId;
    this.nombre = nombre;
    this.rolId=rolId
  }
  static fromJson({ operId, nombre,rolId }) {
    return new opersnrol(operId, nombre,rolId);
  }
}
export default opersnrol;
